import {
  Action, ActionTree,
} from 'vuex';

import {
  SystemMessage,
} from '@/components/SystemMessages/types';
import {
  types,
} from '@/store/modules/system-messages/mutation-types';
import {
  State,
} from '@/store/modules/system-messages/types';
import {
  RootState,
} from '@/store/types';

const add: Action<State, RootState> = ({ commit }, message: SystemMessage): void => {
  commit(types.ADD, message);
};

const remove: Action<State, RootState> = ({ commit }, id: number): void => {
  commit(types.REMOVE, id);
};

const clear: Action<State, RootState> = ({ commit }): void => {
  commit(types.CLEAR);
};

export const actions: ActionTree<State, RootState> = {
  add,
  remove,
  clear,
};
